import { render } from "./TeachingExercise.vue?vue&type=template&id=c474efaa&scoped=true"
import script from "./TeachingExercise.vue?vue&type=script&lang=js"
export * from "./TeachingExercise.vue?vue&type=script&lang=js"

import "./TeachingExercise.vue?vue&type=style&index=0&id=c474efaa&lang=scss"
import "./TeachingExercise.vue?vue&type=style&index=1&id=c474efaa&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c474efaa"]])

export default __exports__